import { render, staticRenderFns } from "./MaterialModelsCreateEdit.vue?vue&type=template&id=16146dc8&scoped=true"
import script from "./MaterialModelsCreateEdit.vue?vue&type=script&lang=js"
export * from "./MaterialModelsCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterialModelsCreateEdit.vue?vue&type=style&index=0&id=16146dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16146dc8",
  null
  
)

export default component.exports